import { toast } from '@shared/ui/feedback/Toast';

/**
 * Confirms a one-time code actually went out. This is the only feedback on a resend,
 * where the screen itself never changes.
 */
export function otpSentToast(method: 'email' | 'mobile', target: string): void {
  toast.success(
    'Code sent',
    method === 'mobile' ? `We texted a code to ${target}.` : `We emailed a code to ${target}.`,
  );
}
